import { render, staticRenderFns } from "./SignaturesList.vue?vue&type=template&id=32f721dd&scoped=true&lang=pug"
import script from "./SignaturesList.vue?vue&type=script&lang=js"
export * from "./SignaturesList.vue?vue&type=script&lang=js"
import style0 from "./SignaturesList.vue?vue&type=style&index=0&id=32f721dd&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f721dd",
  null
  
)

export default component.exports